angular.module('jrBannerFixed', ['jrConfig']).directive('jrElementsFixable', jrElementsFixable);

jrElementsFixable.$inject = ['$window', 'EventsService'];

function jrElementsFixable($window, EventsService) {
  return {
    restrict: 'A',
    link(scope, element, attrs) {
      let fixableBanner = document.getElementsByClassName('js-fixable')[0];
      let headerFixedHeight;
      let footerOffset;
      let bannerHeight = 0;
      let inpageRightsideProposal;
      let inpageRightsideProposalHeight;
      let isFooterVisible;
      let notFixableOffset;
      let lastScrollTop = 0;

      EventsService.on.tmsWidgetLoaded(function (evt, data) {
        const lastFixableBanner = document.querySelectorAll('.js-fixable:last-child');
        if (lastFixableBanner.length) {
          [fixableBanner] = lastFixableBanner;
          angular.element($window).one('scroll', throttle(callback, 0));
        }
      });

      scope.scroll = parseInt($window.pageYOffset, 10);

      function throttle(fn, wait) {
        let time = Date.now();
        return function () {
          if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
          }
        };
      }

      angular.element($window).bind('scroll', throttle(callback, 0));

      function callback() {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        const bGtpMiddle = document.getElementById('b_gtp_middle');
        const headerFixed = document.getElementsByClassName(
          screen.width < 1024 ? 'js-mobile-search-box' : 'js-header-bottom'
        );

        scope.scroll = parseInt($window.pageYOffset, 10);

        inpageRightsideProposal = document.getElementById('inpage-rightside-proposal');
        headerFixedHeight = headerFixed ? parseInt(headerFixed[0].offsetHeight, 10) : 0;
        footerOffset = parseInt(document.getElementsByTagName('footer')[0].offsetTop, 10);
        if (bGtpMiddle) {
          bannerHeight = bGtpMiddle.offsetHeight;
        }
        inpageRightsideProposalHeight = inpageRightsideProposal
          ? inpageRightsideProposal.offsetHeight
          : 0;

        isFooterVisible =
          footerOffset - scope.scroll - 25 < bannerHeight + inpageRightsideProposalHeight;

        if (fixableBanner) {
          if (fixableBanner.getBoundingClientRect().top <= headerFixedHeight) {
            notFixableOffset = window.pageYOffset;
            if (fixableBanner) {
              fixableBanner.classList.add('fixed');
            }
            if (inpageRightsideProposal) {
              inpageRightsideProposal.classList.add('fixed');
              inpageRightsideProposal.classList.add('animated');
            }

            if (isFooterVisible && footerOffset > 0) {
              fixableBanner.style.top = `${
                footerOffset - scope.scroll - 25 - (bannerHeight + inpageRightsideProposalHeight)
              }px`;
              if (inpageRightsideProposal) {
                inpageRightsideProposal.style.top = `${
                  footerOffset - scope.scroll - 25 - (bannerHeight + inpageRightsideProposalHeight)
                }px`;
              }
            } else {
              fixableBanner.style.top = '';
              if (inpageRightsideProposal) {
                inpageRightsideProposal.style.top = '';
              }
            }
          }
        } else {
          const fixedClass =
            typeof isAdBlockerDisabled === 'undefined' ? 'ad-blocker-fixed' : 'fixed';

          if (
            inpageRightsideProposal &&
            headerFixed &&
            headerFixed[0].className.indexOf('fixed') > 0
          ) {
            inpageRightsideProposal.classList.add(fixedClass);
            inpageRightsideProposal.classList.add('animated');
          } else if (inpageRightsideProposal) {
            inpageRightsideProposal.classList.remove(fixedClass);
            inpageRightsideProposal.classList.remove('animated');
          }
        }

        if (
          st <= lastScrollTop &&
          window.pageYOffset <=
            notFixableOffset - (inpageRightsideProposal ? inpageRightsideProposal.offsetHeight : 0)
        ) {
          if (fixableBanner) {
            fixableBanner.classList.remove('fixed');
          }
          if (inpageRightsideProposal) {
            inpageRightsideProposal.classList.remove('fixed');
            inpageRightsideProposal.classList.remove('animated');
          }
        }

        lastScrollTop = st <= 0 ? 0 : st;
      }
    },
  };
}
